import {
  ADD_OPTION_CHAIN_INSTRUMENTS,
  SET_REALTIME_DATA_OC_TIME,
  SAVE_STRIKE_DATA,
  SAVE_INSTRUMENT_EXPIRY,
  SAVE_INSTRUMENT_SPOT_PRICE,
  SAVE_OP_TICK_DATA,
  SAVE_SYN_FUT_PRICE,
  SAVE_FUT_PRICE,
  SAVE_SYN_FUT_TOKEN,
  SAVE_MIDDLE_STRIKE
} from '../../util/actionTypes.js';
import {
  getOptionChainInstrumentsNames,
  getOptionChainExpiries,
  getSpotToken,
  getSpotTokenPrice,
  getOptionChainInstruments,
  getTick,
  getChartData,
  getChartDataOptionOI,
  getHolidaysByExchange,
  getsearchAPIRequest,
  getStockSectorAPIRequest,
  getOptionInstrumentByStrikeRequest
} from '../../api/dataApi';
import { toast } from 'components/common/custom-toast/Toast.js';

export const getInstruments = () => async (dispatch) => {
  const res = await getOptionChainInstrumentsNames();
  try {
    if (res.code === 200) {
      return res.data?.values;
      
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code search-option-chain instrument names");
      console.log('error response code search-option-chain instrument names');
    }
  } catch (error) {
    console.log(
      'error processing option-chain-instrument names request :',
      error
    );
  }
};
 
export const getExpiries = (  instrument) => async (dispatch) => {

  const res = await getOptionChainExpiries(instrument);
  try {
    if (res.code === 200) {
      const data = res.data?.expiries;
      if (data) {
        dispatch({
          type: SAVE_INSTRUMENT_EXPIRY,
          payload: data,
        });
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code getOptionChainExpiries instrument");
      console.log('error response code getOptionChainExpiries instrument');
    }
  } catch (error) {
    console.log('error processing getOptionChainExpiries request :', error);
  }
};

export const getPrice = async (instrument, exchange, spotToken) => {
  try {
    let token = spotToken;
    let segment = '';
    let lotSize = '';
    let exchangeToken = '';
    let tradingSymbol = '';
    const res1 = await getSpotToken(instrument, exchange);
    if (res1.code === 200) {
      token = res1.data[0]?.instrumentToken;
      segment = res1.data[0]?.segment;
      lotSize = res1.data[0]?.lotSize;
      exchangeToken = res1.data[0]?.exchangeToken;
      tradingSymbol  = res1.data[0]?.tradingSymbol
    } else if (res1.code === 403) {
      toast.error(res1.error);
      return { sessionExpired: true };
    } else if(res1.error) {
      toast.error(res1.error || "error response code getSpotToken instrument");
      console.log('error response code getSpotToken instrument');
    }

    if (token) {
      const res2 = await getSpotTokenPrice(token);
      if (res2.code === 200) {
        const lp = res2?.data[token]?.lp;
        if (lp) {
          return { lp: lp, tradingSymbol:tradingSymbol, exchangeToken:exchangeToken, token: token, lotSize:lotSize, segment: segment, data: res2 };
        }
      } else if (res2.code === 403) {
        toast.error(res2.error);
        return { sessionExpired: true };
      }else {
        toast.error(res2.error || "error response code getSpotTokenPrice instrument");
        console.log('error response code getSpotTokenPrice instrument');
      }
    }
  } catch (error) {
    console.log('error processing spot token requests :', error);
  }
};

export const getOptionChainInstrumentsData = (  instrument,expiry, stikes) => async (dispatch) => {
  const res1 = await getOptionChainInstruments(instrument, expiry);
  try {
    if (res1.code === 200) {
      const futExpiry = res1?.data?.fut['expiries'][0];
      const res = {
        optData: res1?.data?.opt[expiry],
        futData: res1?.data?.fut, 
        futToken: res1?.data?.fut[futExpiry][0]?.instrumentToken,
        lotSize: res1?.data?.opt[expiry][0].lotSize,
        volumeFreeze: res1?.data?.opt[expiry][0].volumeFreeze,
        segment: res1?.data?.fut[futExpiry][0]?.segment,
      };
      dispatch({
        type: ADD_OPTION_CHAIN_INSTRUMENTS,
        payload: res,
      });

      return res
    } else if (res1.code === 403) {
      toast.error(res1.error);
      return { sessionExpired: true };
    } else if(res1.error) {
      toast.error(res1.error || "error response code getOptionChainInstrumentsData");
      console.log('error response code getOptionChainInstrumentsData');
    }
  } catch (error) {
    console.log(
      'error processing spot getOptionChainInstrumentsData requests:',
      error
    );
  }
};


export const getOptionChainInstrumentsWithoutDispatch = async(instrument,expiry) =>  {

  const res1 = await getOptionChainInstruments(instrument, expiry);
  try {
    if (res1.code === 200) {
      const futExpiry = res1?.data?.fut['expiries'][0];
      const res = {
        optData: res1?.data?.opt[expiry],
        futData: res1?.data?.fut,
        futToken: res1?.data?.fut[futExpiry][0]?.instrumentToken,
        lotSize: res1?.data?.opt[expiry][0].lotSize,
        volumeFreeze: res1?.data?.opt[expiry][0].volumeFreeze,
        segment: res1?.data?.fut[futExpiry][0]?.segment,
      };
     
      
      return res
    } else if (res1.code === 403) {
      toast.error(res1.error);
      return { sessionExpired: true };
    } else if(res1.error) {
      toast.error(res1.error || "error response code getOptionChainInstrumentsData");
      console.log('error response code getOptionChainInstrumentsData');
    }
  } catch (error) {
    console.log(
      'error processing spot getOptionChainInstrumentsData requests:',
      error
    );
  }
};
export const getTicksData = async (instruments) => {
  const res = await getTick(instruments);
  try {
    if (res.code === 200) {
      return res.data;
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code getTick");
      console.log('error response code getTick');
    }
  } catch (error) {
    console.log(
      'error processing spot getOptionChainInstrumentsData requests:',
      error
    );
  }
};

export const saveTicksData = ( instruments) => async (dispatch) => {
   
  const res = await getTick(instruments);
  try {
    if (res.code === 200) {
      // dispatch({
      //   type: SAVE_OP_TICK_DATA,
      //   payload: res.data,
      // });
      dispatch(saveOPtickData(res.data))
      return res.data;
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code getTick");
      console.log('error response code getTick');
    }
  } catch (error) {
    console.log(
      'error processing spot getOptionChainInstrumentsData requests:',
      error
    );
  }
};

export const getHistoryChartData = async (
  symbol,
  to,
  from,
  seletedInterval
) => {
  try {
    if (symbol) {
      const res = await getChartData(symbol, to, from, seletedInterval);
      if (res.code === 200) {
        return res.data?.[symbol];
      } else if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired: true };
      }else if(res.error) {
        toast.error(res.error || "error response code getChartData");
        console.log('error response code getChartData');
      }
    }
  } catch (error) {
    console.log('error processing get History Chart Data request :', error);
  }
};

export const getHistoryChartDataOptionOI = async (
  symbol,
  to,
  from,
  seletedInterval
) => {
  try {
    if (symbol) {
      const res = await getChartDataOptionOI(symbol, to, from, seletedInterval);
     

      if (res.code === 200) {
        return res.data;
      } else if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired: true };
      }else if(res.error) {
        toast.error(res.error || "error response code getChartDataOptionOI");
        console.log('error response code getChartDataOptionOI');
      }
    }
  } catch (error) {
    console.log('error processing get History Chart Data request :', error);
  }
};

 

export const getHistoryChartDataForSymbolArray = async (
  symbols,
  to,
  from,
  seletedInterval
) => {
  try {
    if (symbols && symbols.length > 0) {
      const res = await getChartData(symbols, to, from, seletedInterval);
      if (res.code === 200) {
        return res.data;
      } else if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired: true };
      }else if(res.error) {
        toast.error(res.error || "error response code getChartData");
        console.log('error response code getChartData');
      }
    }
  } catch (error) {
    console.log(
      'error processing get History Chart multiple Data request :',
      error
    );
  }
};

 

export const getHolidays = async (exgs) => {
  try {
    if (exgs) {
      const res = await getHolidaysByExchange(exgs);
      if (res.code === 200) {
        return res.data;
      } else if (res.code === 403) {
        toast.error(res.error);
        return { sessionExpired: true };
      }else if(res.error) {
        toast.error(res.error || "error response code getHolidaysByExchange");
        console.log('error response code getHolidaysByExchange');
      }
    }
  } catch (error) {
    console.log('error processing get History Chart Data request :', error);
  }
};

export const getsearchAPI = async (params, filter) => {
  var res = [];
  if (filter) {
    res = await getsearchAPIRequest(params, filter);
  } else {
    res = await getsearchAPIRequest(params, '');
  }
  try {
    if (res.code === 200) {
      const data = res.data?.values;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code search API to get all 3 futures tokens");
      console.log('error response code search API to get all 3 futures tokens');
    }
  } catch (error) {
    console.log(
      'error processing search API to get all 3 futures tokens :',
      error
    );
  }
};

export const getStockSectorAPI = async () => {
  const res = await getStockSectorAPIRequest();
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else if(res.error) {
      toast.error(res.error || "error response code Stock Sector API");
      console.log('error response code Stock Sector API');
    }
  } catch (error) {
    console.log('error response code Stock Sector API :', error);
  }
};



 export const saveStrikeData = (data) => async (dispatch) => {
   dispatch({
     type: SAVE_STRIKE_DATA,
     payload: data,
   });
 }


 export const saveSpotPrice = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_INSTRUMENT_SPOT_PRICE,
    payload: data,
  });
}

export const saveSyntPrice = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_SYN_FUT_PRICE,
    payload: data,
  });
}

export const saveSynToken = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_SYN_FUT_TOKEN,
    payload: data,
  });
}

export const saveFutPrice = (data) => async (dispatch) => {
  dispatch({
    type: SAVE_FUT_PRICE,
    payload: data,
  });
}

export const saveMiddleStrike = (strike) => async (dispatch) => {
  dispatch({
    type: SAVE_MIDDLE_STRIKE,
    payload: strike,
  });
}
 
 export const getOptionInstrumentByStrike = async (name, type, expiry, strike) => {
  const res = await getOptionInstrumentByStrikeRequest(name, type, expiry, strike);
  try {
 
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      toast.error(res.error);
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "error response code option_instrument API");
      console.log("error response code option_instrument API");
    }
  } catch (error) {
    console.log("error response code option_instrument API :", error);
  }
};
export const saveOPtickData = (res) => async (dispatch) => {

    dispatch({
      type: SAVE_OP_TICK_DATA,
      payload: res,
    });
}